import tagTester from './_tagTester.js';

export default tagTester('Number');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isNumber.js
// module id = 656
// module chunks = 0